import coursesApi from 'Api/axios/courses-api';
import { downloadFile } from './file-utils';

/**
 * Obtiene y genera el certificado del empleado si se cumple lo siguiente;
 * - El empleado finalizado el curso.
 * - La calificación del empleado es aprobatoria.
 *
 * @param coursesId - id del curso que se desea obtener el certificado
 * @param employeeId  - id del empleado
 * @param certificationId - id del certificado
 */
const handleDownloadCertificate = async (
  coursesId: string,
  employeeId: string,
  certificationId: string,
  filename: string
) => {
  try {
    const response = await coursesApi.downloadCertificate(coursesId, employeeId, certificationId);
    if (response.data) {
      downloadFile(response.data, filename);
    }
  } catch (error) {
    console.error('Error downloading certificate:', error);
  }
};

export { handleDownloadCertificate };
